//services
import { getSuggestedAltshulerAccountByCompanyId, validateStep3 } from 'services/balance.services';

//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import {
	getAltshulerBankAccount,
	getCompanyBankAccount,
	getTranfserAmount,
	isLoading,
	setAltshulerBankAccount,
} from 'state/reducers/balance.reducers';

//components
import TransferDetailsForm from './TransferDetailsForm';
import { FormButton } from 'theme/elements/Buttons';
//sections
//mui
import { LoadingButton } from '@mui/lab';
import { Button, Stack } from '@mui/material';

//constants
import { invalidFields } from 'components/FormCreator/types';

import { Fragment, useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
import { balanceSteps } from 'constants/balance.constants';
import { getMobile } from 'state/reducers/ui.reducers';
import WaitingMessage from 'components/WaitingMessage';
import { getAltshulerAccountsByCompanyId } from 'services/bank-account.services';

export default function Step3(props: { handleCancel: any; transferProofFile: File | null; handleBack: any }) {
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();

	const companyBankAccountId = useAppSelector(getCompanyBankAccount);
	const altshulerBankAccountId = useAppSelector(getAltshulerBankAccount);
	const transferAmount = useAppSelector(getTranfserAmount);
	const isMobile = useAppSelector(getMobile);
	const [invalidFields, setInvalidFields] = useState<invalidFields>({});
	const loading: boolean = useAppSelector(isLoading);
	const isContinueDisabled = useMemo(() => {
		return loading || !!_.keys(invalidFields).length;
	}, [loading, invalidFields]);

	const handleBankListPick = (accountId: number) => {
		dispatch(setAltshulerBankAccount(accountId));
	};
	const handleForm = () => {
		dispatch(validateStep3(companyBankAccountId, altshulerBankAccountId, transferAmount, props.transferProofFile!));
	};

	return (
		<Fragment>
			<TransferDetailsForm handleBankListPick={handleBankListPick} invalidFields={invalidFields} />
			<Stack justifyContent="space-between" direction="row" marginTop="32px">
				{!isMobile && (
					<FormButton>
						<Button disabled={loading} variant="text" onClick={props.handleCancel}>
							{t('page.balance.add.step.3.cancel_button.text')}
						</Button>
					</FormButton>
				)}
				<Stack justifyContent="space-between" direction="row">
					<FormButton>
						<Button variant="outlined" onClick={() => props.handleBack(balanceSteps.Currency)}>
							{t('page.balance.add.step.3.back_button.text')}
						</Button>
					</FormButton>
					<FormButton sx={{ marginLeft: '8px' }}>
						<LoadingButton variant="contained" disabled={isContinueDisabled} onClick={handleForm}>
							{t('page.balance.add.step.3.continue_button.text')}
						</LoadingButton>
					</FormButton>
				</Stack>
			</Stack>
		</Fragment>
	);
}
